<template>
  <div
    class="modal_wrapper active"
    @click="closeModal()"
  >
    <div
      class="modal_window white_box create_report_modal"
      @click.stop=""
    >
      <div class="modal_header">
        <h3 class="heading">
          My Widgets
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>
      <div class="section_modal_content white_box flex edit_section_modal mb_16">
        <div class="content">
          <table
            v-if="customWidgets.length > 0"
            class="table_component"
          >
            <thead>
              <tr>
                <td style="width:30%">
                  <span>Widget Name</span>
                </td>
                <td style="width:40%">
                  <span>Content</span>
                </td>
                <td>
                  <span>In use</span>
                </td>
                <td>
                &nbsp;
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(widget, index) in customWidgets"
                :key="index"
              >
                <td>
                  {{ widget.heading }}
                </td>
                <td>
                  <div
                    class="widget_content"
                    style="max-width:100%"
                  >
                    {{ widget.code }}
                  </div>
                </td>
                <td>
                  {{ inUseWidgets.includes(widget.id) ? 'Yes' : 'No' }}
                  <a
                    v-if="!inUseWidgets.includes(widget.id)"
                    href="javascript:;"
                    @click="addCustomWidget(widget)"
                  >(Add)</a>
                </td>
                <td class="edit_button">
                  <a
                    class="btn btn_sm primary_btn tooltipster"
                    href="javascript:;"
                    title="Widget Settings"
                    @click.stop="editWidget(widget)"
                  >
                    <i class="icon settings_icon_white" />
                  </a>
                  <a
                    class="btn btn_sm delete_btn tooltipster"
                    href="javascript:;"
                    title="Delete widget"
                    @click.stop="deleteWidget(widget)"
                  >
                    <svg
                      data-v-25f67a06=""
                      fill="none"
                      height="15"
                      viewBox="0 0 14 15"
                      width="14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.8125 3.5625L2.1875 3.56251"
                        data-v-25f67a06=""
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      />
                      <path
                        d="M5.6875 6.1875V9.6875"
                        data-v-25f67a06=""
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      />
                      <path
                        d="M8.3125 6.1875V9.6875"
                        data-v-25f67a06=""
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      />
                      <path
                        d="M10.9375 3.5625V11.875C10.9375 11.991 10.8914 12.1023 10.8094 12.1844C10.7273 12.2664 10.616 12.3125 10.5 12.3125H3.5C3.38397 12.3125 3.27269 12.2664 3.19064 12.1844C3.10859 12.1023 3.0625 11.991 3.0625 11.875V3.5625"
                        data-v-25f67a06=""
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      />
                      <path
                        d="M9.1875 3.5625V2.6875C9.1875 2.45544 9.09531 2.23288 8.93122 2.06878C8.76712 1.90469 8.54456 1.8125 8.3125 1.8125H5.6875C5.45544 1.8125 5.23288 1.90469 5.06878 2.06878C4.90469 2.23288 4.8125 2.45544 4.8125 2.6875V3.5625"
                        data-v-25f67a06=""
                        stroke="white"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      />
                    </svg>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <div
            v-else
            class="no_widgets"
          >
            You don't currently have any custom widgets.
          </div>
        </div>
      </div>
      <div class="section_modal_footer">
        <button
          class="btn btn_md primary_btn"
          @click="createCustomWidget()"
        >
          <span>Create</span>
        </button>
        <button
          class="btn btn_md secondary_btn"
          @click="closeModal()"
        >
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Swal from 'sweetalert2';
import {mapActions, mapState} from 'vuex'

export default {
  emits: [
    'add-widget',
    'create-widget',
    'edit-widget',
  ],
  data() {
    return {
      newCustomWidget: {
        create: true,
      }
    }
  },
  computed: {
    ...mapState('dashboard', ['layout', 'customWidgets']),
    items() {
      let items = [];
      if (this.customWidgets.length > 0) {
        items = [
          {
            name: 'My Widgets',
            options: [
              ...this.customOptions
            ]
          },
        ];
      }
      return items;
    },
    customOptions() {
      let options = [];
      _.each(this.customWidgets, (widget) => {
        options.push({
          name: widget.heading,
          widget: {
            "w": 1,
            "id": `${widget.heading}-${widget.id}`,
            "component": "CustomWidget",
            "custom_widget_id": widget.id,
          },
        })
      });
      return options;
    },
    inUseWidgets() {
      let inUse = [];
      if (this.layout) {
        _.each(this.customWidgets, widget => {
          let index = _.findIndex(this.layout, ['id', `${widget.heading}-${widget.id}`]);
          if (index >= 0) {
            inUse.push(widget.id);
          }
        });
      }
      return inUse;
    }
  },
  methods: {
    ...mapActions({
      closeCustomWidgetModal: 'dashboard/closeCustomWidgetModal',
      openMyWidgetsModal: 'dashboard/openMyWidgetsModal',
      saveLayout: 'dashboard/saveLayout',
      deleteCustomWidget: 'dashboard/deleteCustomWidget',
      closeModal: 'dashboard/closeMyWidgetsModal',
      removeWidget: 'dashboard/removeWidget',
    }),
    addCustomWidget(widget) {
      let customWidget = {
        "w": 1,
        "id": `${widget.heading}-${widget.id}`,
        "component": "CustomWidget",
        "custom_widget_id": widget.id,
      }
      this.$emit('add-widget', {widget: customWidget})
    },
    createCustomWidget() {
      this.closeModal();
      this.$emit('create-widget');
    },
    editWidget(widget) {
      widget.custom_widget_id = widget.id;
      this.$emit('edit-widget', {widget: widget});
    },
    deleteWidget(widget) {
      Swal.fire({
        title: 'Delete this custom widget?',
        text: "Are you sure? You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#37B2A8',
        cancelButtonColor: '#F34F4F',
        confirmButtonText: 'Yes, delete it!',
        showLoaderOnConfirm: true,
        backdrop: true,
        preConfirm: async () => {
          this.deleteIfExists(`${widget.heading}-${widget.id}`);
          await this.saveLayout();
          await this.deleteCustomWidget(widget.id).then(() => {
            this.closeCustomWidgetModal();
            this.openMyWidgetsModal();
          });
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: `Deleted successfully`,
            icon: 'success'
          });
          this.selected = [];
        }
      });
    },
    deleteIfExists(idPrefix) {
      let exists = false;
      if (this.layout) {
        _.forEach(this.layout, widget => {
          if (widget.id.includes(idPrefix)) {
            this.removeWidget(widget);
          }
        });
      }
      return exists;
    }
  }
}
</script>

<style scoped>
.content {
  width: 100%;
}
</style>
<style scoped>
tr td:not(:first-of-type) {
  text-align: center;
}

td.edit_button {
  display: flex;
  justify-content: space-evenly;
}

td.edit_button a {
  margin: 0;
  padding: 5px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.widget_content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.no_widgets {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 700;
}

.section_modal_footer {
  display: flex;
  justify-content: flex-end;
}

.section_modal_footer button {
  height: 43px;
  padding: 0 1.5rem;
}
</style>
